import React, { createContext, useContext, useState, useEffect } from 'react';
import pb from '../lib/pocketbase';

const HomeContext = createContext();

export const HomeProvider = ({ children }) => {
    const [sections, setSections] = useState([]);
    const [loading, setLoading] = useState(true);

    const refreshHomeData = async () => {
        setLoading(true);
        try {
            const records = await pb.collection('home_sections').getFullList({
                sort: 'order',
                filter: 'is_published = true',
            });
            setSections(records);
        } catch (error) {
            console.error("Erreur lors de la récupération des sections d'accueil:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        refreshHomeData();
    }, []);

    return (
        <HomeContext.Provider value={{ sections, loading, refreshHomeData }}>
            {children}
        </HomeContext.Provider>
    );
};

export const useHomeData = () => {
    const context = useContext(HomeContext);
    if (!context) {
        throw new Error('useHomeData doit être utilisé au sein d\'un HomeProvider');
    }
    return context;
};
